
export const filterAlt = (alt) => {
	return alt.replaceAll('image', '');
}
